import {createSlice} from "@reduxjs/toolkit";
import {getCalendarWeekly} from "./action";

const initialState = {
	state: {weeks_count: 0, items: []},
	loading: true,
	error: ''
} as BaseState<CalendarWeeklyResponse>

const slice = createSlice({
	name: 'calendarWeeklySlice',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getCalendarWeekly.pending, () => ({
				state: {weeks_count: 0, items: []},
				loading: true
			})
		)
		builder.addCase(getCalendarWeekly.fulfilled, (state, action) => (
				{
					state:  {weeks_count: action.payload.weeks_count, items:  action.payload.items},
					loading: false,
					error: null
				}
			)
		)
		builder.addCase(getCalendarWeekly.rejected, () => ({
				state: {weeks_count: 0, items: []},
				loading: false,
				error: 'Failed to get calendars weekly, please try again'
			})
		)
	}
})

export default slice
